// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__13GR2","ranges":"BmiRanges_ranges__3etJ_"};